import ProductContext from '../../../../_helper/Ecommerce/Product';
import { H4, LI, P, Image, UL } from '../../../../AbstractElements';
import React, { Fragment, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { Row, Card, Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { Featured, Next, OutOfStock, Previous } from '../../../../Constant';

const ProductGrid = ({ productList, perPage, currentPage, onPageChange }) => {
    const { symbol } = useContext(ProductContext);

    const totalPages = Math.ceil(productList.length / perPage);
    const startIndex = (currentPage - 1) * perPage;
    const paginatedList = productList.slice(startIndex, startIndex + perPage);

    return (
        <Fragment>
            <div className="product-wrapper-grid">
                <Row className="gridRow">
                    {
                        paginatedList?.length < 0 ?

                        <div className='d-flex justify-content-center ' style={{height:'40vh'}}> 
                                <p>
                                    No products available at the moment. Please check back later
                                </p>
                            </div>:
                        paginatedList.map((item) => (
                            <div id="gridId" className='col-xl-3 col-lg-4 col-sm-6 xl-3' key={item.id}>
                                <Card>
                                    <div className="product-box">
                                        {/* Product Image and Tags */}
                                        <div className="product-img" style={{ cursor: 'pointer' }}>
                                            <Link to={{ pathname: `${process.env.PUBLIC_URL}/product-details` }} state={{ id: item.id }}>


                                                {item.stock < item?.min_order && <span className="ribbon ribbon-danger">Out Of Stock</span>}
                                                {item.featured === 1 && item.stock > item?.min_order && (
                                                    <span className="ribbon ribbon-success ribbon-right">Featured</span>
                                                )}
                                                <Image attrImage={{
                                                    className: 'img-fluid',
                                                    src: item.item_image,
                                                    alt: '',
                                                    style: { width: '100%', height: '350px', objectFit: 'contain' },
                                                }} />
                                                <div className="product-hover">
                                                    {/* <UL attrUL={{ className: 'simple-list flex-row' }}>
                                                <LI>
                                                    <Link to={{ pathname: `${process.env.PUBLIC_URL}/product-details` }} state={{ id: item.id }}>
                                                        <i className='icon-eye me-0' />
                                                    </Link>
                                                </LI>
                                            </UL> */}
                                                </div>
                                            </Link>
                                        </div>
                                        {/* Product Info */}
                                        <div className="product-details">
                                            <Link to={{ pathname: `${process.env.PUBLIC_URL}/product-details` }} state={{ id: item.id }}>
                                                <H4>{item.name}</H4>
                                            </Link>
                                            <P>{item.note}</P>
                                            <div className="product-price">{symbol} {item.sale_price}</div>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        )) 
                    }
                </Row>

                {/* Pagination */}
                {totalPages > 1 && (
                    <nav className="m-b-30" aria-label="Page navigation example">
                        <Pagination className="pagination justify-content-center pagination-primary">
                            <PaginationItem disabled={currentPage === 1}>
                                <PaginationLink onClick={() => onPageChange(currentPage - 1)}>{Previous}</PaginationLink>
                            </PaginationItem>

                            {Array.from({ length: totalPages }).map((_, i) => (
                                <PaginationItem key={i} active={currentPage === i + 1}>
                                    <PaginationLink onClick={() => onPageChange(i + 1)}>{i + 1}</PaginationLink>
                                </PaginationItem>
                            ))}

                            <PaginationItem disabled={currentPage === totalPages}>
                                <PaginationLink onClick={() => onPageChange(currentPage + 1)}>{Next}</PaginationLink>
                            </PaginationItem>
                        </Pagination>
                    </nav>
                )}
            </div>
        </Fragment>
    );
};

export default ProductGrid;
